const ENDPOINTS = {

	GET_EMPLEADOS: () =>
		'/api/v1/empleados/establecimiento/',
		
	GET_TIPOS_EMPLEADO: () =>
		'/api/v1/empleados/tiposEmpleado/',
		
	GET_EMPLEADOS_BY_PARAMS: (establecimientoId, activo, nombre, idTipo) => {
		let url = '/api/v1/empleados/establecimiento/' + establecimientoId +
		'?estado=' + activo +
		'&nombre:ct=' + nombre;
		
		if (idTipo != "" && idTipo != null) {
			url += '&idTipo=' + idTipo
		}
		return url;
	},	

	POST_EMPLEADOS: () =>
		'/api/v1/empleados/',

	DELETE_EMPLEADO: () =>
		'/api/v1/empleados/',

	ACTUALIZAR_EMPLEADO: (id) =>
		'/api/v1/empleados/' + id,
		
	ASIGNAR_HABITACIONES : () => 
	'/api/v1/habitaciones/asignar'
	
};

export default ENDPOINTS;